import { useDispatch } from 'react-redux';
import { useRootSelector } from '../stores/reducers/root';
import { setTheme, toggleTheme, ThemeMode } from '../stores/reducers/theme.reducer';

export const useTheme = () => {
  const dispatch = useDispatch();
  const theme = useRootSelector((state) => state.theme.mode);

  const setThemeMode = (mode: ThemeMode) => {
    dispatch(setTheme(mode));
  };

  const toggleThemeMode = () => {
    dispatch(toggleTheme());
  };

  const isDark = theme === 'dark';
  const isLight = theme === 'light';

  return {
    theme,
    isDark,
    isLight,
    setTheme: setThemeMode,
    toggleTheme: toggleThemeMode,
  };
}; 